import { render, staticRenderFns } from "./editIssueForm.vue?vue&type=template&id=23285ab2&"
import script from "./editIssueForm.vue?vue&type=script&lang=ts&"
export * from "./editIssueForm.vue?vue&type=script&lang=ts&"
import style0 from "./editIssueForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports